<template lang="pug">
div
  slot
</template>

<script>
export default {
  props: {
  },
  computed: {
  },
  mounted () {
    const buttons = this.$el.querySelectorAll('.c-progress-form__element')
    window.addEventListener('scroll', (e) => { this.highlightOnScroll(buttons, e.target.documentElement) })
    this.scrollToNext(buttons)
  },
  methods: {
    getCenterPosition (element) {
      const bounding = element.getBoundingClientRect()
      return bounding.bottom - bounding.height / 2 - window.innerHeight / 2
    },
    highlightOnScroll (buttons, viewport) {
      let buttonArray = Array.from(buttons)
      buttons.forEach((button) => { button.classList.remove('is-highlighted') })
      if (viewport.scrollHeight - viewport.scrollTop === viewport.clientHeight) {
        buttons[buttons.length - 1].classList.add('is-highlighted')
      } else {
        const centerButton = buttonArray.reduce((prev, current) => {
          const currentCenter = this.getCenterPosition(current)
          const prevCenter = this.getCenterPosition(prev)
          return Math.abs(currentCenter) < Math.abs(prevCenter) ? current : prev
        })
        centerButton.classList.add('is-highlighted')
      }
    },
    scrollToNext (buttons) {
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          window.setTimeout(() => {
            const nextButton = button.nextSibling
            const additionalQuestions = button.querySelectorAll('.c-progress-form__additional-questions')
            console.log(additionalQuestions.length)
            if (nextButton !== undefined) {
              if (!additionalQuestions.length) {
                nextButton.scrollIntoView({behavior: 'smooth'})
              }
            }
          }, 300)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/ProgressForm.vue